/** TestRunStatus
 * generated by enums.tst
**/
var TestRunStatus;
(function (TestRunStatus) {
    TestRunStatus[TestRunStatus["RUNNING"] = 1] = "RUNNING";
    TestRunStatus[TestRunStatus["COMPLETE"] = 2] = "COMPLETE";
    TestRunStatus[TestRunStatus["CANCELLED"] = 3] = "CANCELLED";
})(TestRunStatus || (TestRunStatus = {}));
/** TestRunTestCaseStatus
 * generated by enums.tst
**/
var TestRunTestCaseStatus;
(function (TestRunTestCaseStatus) {
    TestRunTestCaseStatus[TestRunTestCaseStatus["QUEUED"] = 0] = "QUEUED";
    TestRunTestCaseStatus[TestRunTestCaseStatus["RUNNING"] = 1] = "RUNNING";
    TestRunTestCaseStatus[TestRunTestCaseStatus["COMPLETE"] = 2] = "COMPLETE";
    TestRunTestCaseStatus[TestRunTestCaseStatus["CANCELLED"] = 3] = "CANCELLED";
})(TestRunTestCaseStatus || (TestRunTestCaseStatus = {}));
